/**
 * Leave module enums (M7, SRS §13, ADR-055). Values are the Postgres enum labels of the `leave`
 * schema (UPPER_SNAKE).
 */
/** How a type's days are counted: working days (CL, SL, EL, LWP) or calendar days (ML, PL). */
export const LEAVE_COUNT_BASES = ['WORKING_DAYS', 'CALENDAR_DAYS'];
/** Quota granted on 1 January (prorated for joiners) or earned from working days (EL). */
export const LEAVE_ACCRUALS = ['UPFRONT', 'EARNED'];
/** Balance ledger entries (FR-LEAVE-3); balance = Σ days. */
export const LEAVE_LEDGER_ENTRIES = [
    'OPENING',
    'GRANT',
    'ACCRUAL',
    'CARRY_FORWARD',
    'LAPSE',
    'TAKEN',
    'REVERSAL',
    'ADJUSTMENT',
];
export const LEAVE_REQUEST_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'];
/** Half-day flag on a request's first / last day (FR-LEAVE-4). */
export const DAY_HALVES = ['FIRST_HALF', 'SECOND_HALF'];
//# sourceMappingURL=enums.js.map